import { Hooks } from 'Components/Hooks';

import {
  Backdrop,
  ViewConnected,
  StatusMessage,
  CallTimer,
  QualityWarning,

  ConfMeters,

  SettingsIconButton,
  DisconnectIconButton,

  FinishTestRecordingButton,

  ViewConnecting,
  QualityMeterModal,
  MediaErrorModal,
  SettingsModal,

  registerDrawLoop,
} from './UIComponents';

import { DebugView } from './DebugComponents';

export default function TestCallUI({ ctrl }) {
  const hooks = new Hooks();

  const ctx = {
    hooks,
    ctrl,
  };

  const root = (
    <div class="test-call-ui">
      <Backdrop ctx={ctx} />
      <DebugView ctx={ctx} />
      <ViewConnected ctx={ctx}>
        <FinishTestRecordingButton ctx={ctx} />
        <StatusMessage ctx={ctx} />
        <CallTimer ctx={ctx} />
        <QualityWarning ctx={ctx} />

        <ConfMeters ctx={ctx} />

        <div class="btn-panel">
          <div class="btn-toolbar-full">
            <SettingsIconButton ctx={ctx} />
            <DisconnectIconButton ctx={ctx} />
          </div>
        </div>
      </ViewConnected>

      <ViewConnecting ctx={ctx} />

      <QualityMeterModal ctx={ctx} />
      <MediaErrorModal ctx={ctx} />
      <SettingsModal ctx={ctx} />
    </div>
  );

  registerDrawLoop(ctrl, root);

  ctrl.on('update', () => hooks.run(ctrl));
  hooks.run(ctrl);

  return root;
}
